import React, { useCallback } from 'react'
import { css } from '@emotion/react'
import { IconButton } from 'shared/ui'

const HamburgerStyle = css`
  padding: 12px 16px 12px 16px;
  line-height: 0;
  transition: transform 150ms ease-in-out;

  &::before {
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
  }
`
const HamburgerStyleCollapsed = css`
  && svg {
    transform: rotate3d(0, 0, 1, -90deg);
    transition: all 75ms ease-in-out;
  }
`

const MenuButton = ({
  doToggleLeftSidebar,
  isLeftSidebarCollapsed,
  onClick,
}) => {
  const handleHamburgerClick = useCallback(
    e => {
      doToggleLeftSidebar()
      if (onClick) {
        onClick(e)
      }
    },
    [doToggleLeftSidebar, onClick]
  )

  return (
    <IconButton
      css={[HamburgerStyle, isLeftSidebarCollapsed && HamburgerStyleCollapsed]}
      data-test-id="Hamburger"
      name="menu"
      svg
      onClick={handleHamburgerClick}
      size="large"
      tooltip={`${isLeftSidebarCollapsed ? 'Show' : 'Hide'} navigation`}
      tooltipPosition="right"
      iconSize={16}
      colorHover="color.globalNav.iconActiveBasic"
    />
  )
}

export default MenuButton
